import { defaultFilterDefinitions, transformedDefaultFilterDefinitions } from '../searchPageFiltersConfig';
export function getOverridesByHostProduct(_ref) {
  let {
    hostProductId,
    enableFlexibleBillingFilter
  } = _ref;
  const filterDefinition = enableFlexibleBillingFilter ? transformedDefaultFilterDefinitions() : defaultFilterDefinitions;
  if (!hostProductId) {
    return {
      filterDefinitions: filterDefinition,
      additionalFilters: {}
    };
  }
  return {
    // for EMCEE we are not showing hosting and product filters
    filterDefinitions: filterDefinition.filter(filter => filter.filterId !== 'hosting' && filter.filterId !== 'product'),
    // for EMCEE we are filtering only cloud products for the host product
    additionalFilters: {
      product: hostProductId,
      hosting: 'cloud'
    }
  };
}